import { SupportedLocale } from "@/i18n";
import { LoginResponse } from "@/lib/auth/auth-types";
import { createContext, useContext } from "react";

interface CMS {
  id: string;
  instanceId: string;
}

interface Instance {
  id: string;
  name: string;
  frontUrl: string;
  s3Bucket: string;
  CMS: CMS;
  hideArtMatchFront: boolean;
  hideArtMatchBO: boolean;
  oeuvresEnVenteURL: string;
  haveEshop: boolean;
}

interface AuthContextType {
  token: string | null;
  login: (
    username: string,
    password: string,
    locale: SupportedLocale,
  ) => Promise<LoginResponse>;
  twoFactorLogin: (
    email: string,
    twoFactorToken: string,
    locale: SupportedLocale,
  ) => Promise<LoginResponse>;
  logout: () => void;
  instance: string | undefined;
  instanceData: Instance | undefined;
  checkToken: () => boolean;
  checkInstanceAndToken: () => boolean;
  setInstance: (instance: string) => void;
  user: {
    id: string;
    email: string;
    authToken: string;
    role: string;
  } | null;
}

export const AuthContext = createContext<AuthContextType | undefined>(
  undefined,
);

export const useAuth = (): AuthContextType => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth doit être utilisé dans un AuthProvider");
  }
  return context;
};
